import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { TimetableDetailEntity, TimetableDetailResponse, TimetablePayload, deserializeTimetableDetail } from 'src/entities/Timetable.entity';

import { invalidateCourseMaster } from './useCourseMutations';
import { TIMETABLES_BASE_PATH, timetableQueryKey } from './useTimetable.query';

export const useCreateTimetableMutation = () => {
  const queryClient = useQueryClient();
  return useMutation<TimetableDetailEntity, Error, TimetablePayload>({
    mutationFn: async (data) => deserializeTimetableDetail((await axios.post<TimetableDetailResponse>(TIMETABLES_BASE_PATH, { data })).data),
    onSuccess: (detail) => { queryClient.setQueryData(timetableQueryKey(detail.id), detail); return invalidateCourseMaster(queryClient); },
  });
};

/**
 * 名前か所属コースの保存（操作ごとの PATCH）。所属が変わるとコースの timetables も変わるので courses も捨てる。
 * 同じダイヤの保存中を詳細の作り直しの後も見分けられるよう mutationKey ['timetableSave'] を付ける（useIsTimetableSaving）
 */
export const useUpdateTimetableMutation = () => {
  const queryClient = useQueryClient();
  return useMutation<TimetableDetailEntity, Error, { id: number; data: TimetablePayload }>({
    mutationKey: ['timetableSave'],
    mutationFn: async ({ id, data }) => deserializeTimetableDetail((await axios.patch<TimetableDetailResponse>(`${TIMETABLES_BASE_PATH}/${id}`, { data })).data),
    onSuccess: (detail) => { queryClient.setQueryData(timetableQueryKey(detail.id), detail); return invalidateCourseMaster(queryClient); },
  });
};

export const useDeleteTimetableMutation = () => {
  const queryClient = useQueryClient();
  return useMutation<void, Error, { id: number }>({
    mutationFn: async ({ id }) => { await axios.delete(`${TIMETABLES_BASE_PATH}/${id}`); },
    // 消したダイヤの詳細は removeQueries も invalidate もしない。表示中だと取り直して 404 になり、詳細が読み込み中に戻って
    // 削除ダイアログごとアンマウントされ、mutate の onSuccess（選択を外す）が呼ばれなくなる。画面が選択を外せば gcTime で消える
    onSuccess: (_result, { id }) => invalidateCourseMaster(queryClient, timetableQueryKey(id)),
  });
};
